import { useTranslation } from 'react-i18next';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useState, useEffect } from 'react';

interface PricingRoute {
  route: string;
  economico: number;
  conforto: number;
  suv: number;
  mpv: number;
  minivan: number;
  minibus: number;
  luxo: number;
}

// Função para verificar se estamos no período de inverno (novembro a março)
const isWinterSeason = () => {
  const currentMonth = new Date().getMonth(); // 0 = Janeiro, 10 = Novembro
  return currentMonth >= 10 || currentMonth <= 2; // Novembro (10) até Março (2)
};

// Função para verificar se a rota é para Espanha
const isSpainRoute = (route: string) => {
  return route.includes('(Espanha)') || route.includes('Gibraltar');
};

// Função para aplicar desconto de inverno
const applyWinterDiscount = (price: number, route: string) => {
  if (isWinterSeason()) {
    // 10% de desconto para rotas em Espanha, 30% para rotas em Portugal
    return isSpainRoute(route) ? price * 0.9 : price * 0.7;
  }
  return price;
};

export default function PricingPage() {
  const { t } = useTranslation();
  const [selectedRoute, setSelectedRoute] = useState<PricingRoute | null>(null);
  const [searchTerm, setSearchTerm] = useState('');

  const routes: PricingRoute[] = [
    { route: 'Aeroporto Faro - Albufeira', economico: 45, conforto: 50, suv: 60, mpv: 65, minivan: 70, minibus: 80, luxo: 135 },
    { route: 'Aeroporto Faro - Vilamoura', economico: 35, conforto: 40, suv: 50, mpv: 55, minivan: 55, minibus: 65, luxo: 90 },
    { route: 'Aeroporto Faro - Quarteira', economico: 35, conforto: 40, suv: 50, mpv: 55, minivan: 55, minibus: 65, luxo: 90 },
    { route: 'Aeroporto Faro - Lagos', economico: 95, conforto: 105, suv: 115, mpv: 125, minivan: 130, minibus: 140, luxo: 190 },
    { route: 'Aeroporto Faro - Portimão', economico: 75, conforto: 85, suv: 95, mpv: 105, minivan: 100, minibus: 115, luxo: 150 },
    { route: 'Aeroporto Faro - Carvoeiro', economico: 70, conforto: 80, suv: 90, mpv: 100, minivan: 95, minibus: 110, luxo: 140 },
    { route: 'Aeroporto Faro - Tavira', economico: 45, conforto: 50, suv: 60, mpv: 65, minivan: 60, minibus: 70, luxo: 90 },
    { route: 'Aeroporto Faro - Sagres', economico: 130, conforto: 145, suv: 155, mpv: 165, minivan: 170, minibus: 190, luxo: 260 },
    { route: 'Aeroporto Faro - Alvor', economico: 75, conforto: 85, suv: 95, mpv: 105, minivan: 100, minibus: 115, luxo: 150 },
    { route: 'Aeroporto Faro - Armação de Pêra', economico: 60, conforto: 65, suv: 75, mpv: 80, minivan: 80, minibus: 95, luxo: 120 },
    { route: 'Aeroporto Faro - Almancil', economico: 30, conforto: 35, suv: 45, mpv: 50, minivan: 45, minibus: 55, luxo: 70 },
    { route: 'Aeroporto Faro - Quinta do Lago', economico: 35, conforto: 40, suv: 50, mpv: 55, minivan: 50, minibus: 60, luxo: 80 },
    { route: 'Aeroporto Faro - Vale do Lobo', economico: 35, conforto: 40, suv: 50, mpv: 55, minivan: 50, minibus: 60, luxo: 80 },
    { route: 'Aeroporto Faro - Olhão', economico: 30, conforto: 35, suv: 45, mpv: 50, minivan: 45, minibus: 55, luxo: 60 },
    { route: 'Aeroporto Faro - Monte Gordo', economico: 70, conforto: 80, suv: 90, mpv: 100, minivan: 90, minibus: 100, luxo: 140 },
    { route: 'Aeroporto Faro - Vila Real de Santo António', economico: 75, conforto: 85, suv: 95, mpv: 105, minivan: 95, minibus: 105, luxo: 150 },
    { route: 'Aeroporto Faro - Ayamonte (Espanha)', economico: 85, conforto: 95, suv: 105, mpv: 115, minivan: 110, minibus: 120, luxo: 170 },
    { route: 'Aeroporto Faro - Huelva (Espanha)', economico: 140, conforto: 160, suv: 170, mpv: 180, minivan: 180, minibus: 200, luxo: 280 },
    { route: 'Aeroporto Faro - Sevilha (Espanha)', economico: 230, conforto: 250, suv: 270, mpv: 280, minivan: 290, minibus: 320, luxo: 450 },
    { route: 'Aeroporto Faro - Lisboa', economico: 290, conforto: 320, suv: 340, mpv: 350, minivan: 360, minibus: 400, luxo: 550 },
    { route: 'Aeroporto Faro - Praia da Rocha', economico: 75, conforto: 85, suv: 95, mpv: 105, minivan: 100, minibus: 115, luxo: 150 },
    { route: 'Aeroporto Faro - Burgau', economico: 100, conforto: 115, suv: 125, mpv: 135, minivan: 135, minibus: 150, luxo: 200 },
    { route: 'Aeroporto Faro - Salema', economico: 110, conforto: 125, suv: 135, mpv: 145, minivan: 145, minibus: 160, luxo: 220 },
    { route: 'Aeroporto Faro - Praia da Luz', economico: 95, conforto: 105, suv: 115, mpv: 125, minivan: 130, minibus: 140, luxo: 190 },
    { route: 'Aeroporto Faro - Montechoro', economico: 45, conforto: 50, suv: 60, mpv: 65, minivan: 70, minibus: 80, luxo: 135 },
    { route: 'Aeroporto Faro - Galé', economico: 50, conforto: 55, suv: 65, mpv: 70, minivan: 75, minibus: 85, luxo: 140 },
    { route: 'Aeroporto Faro - Olhos de Água', economico: 40, conforto: 45, suv: 55, mpv: 60, minivan: 65, minibus: 75, luxo: 120 },
    { route: 'Aeroporto Faro - Ferragudo', economico: 70, conforto: 80, suv: 90, mpv: 100, minivan: 95, minibus: 110, luxo: 140 },
    { route: 'Aeroporto Faro - Porches', economico: 65, conforto: 75, suv: 85, mpv: 95, minivan: 90, minibus: 105, luxo: 130 },
    { route: 'Aeroporto Faro - Silves', economico: 65, conforto: 75, suv: 85, mpv: 95, minivan: 90, minibus: 105, luxo: 130 },
    // Novas rotas para Espanha
    { route: 'Aeroporto Faro - Alicante (Espanha)', economico: 580, conforto: 620, suv: 660, mpv: 700, minivan: 740, minibus: 820, luxo: 1160 },
    { route: 'Aeroporto Faro - Almeria (Espanha)', economico: 420, conforto: 460, suv: 500, mpv: 540, minivan: 580, minibus: 660, luxo: 840 },
    { route: 'Aeroporto Faro - Barcelona (Espanha)', economico: 980, conforto: 1040, suv: 1100, mpv: 1160, minivan: 1220, minibus: 1340, luxo: 1960 },
    { route: 'Aeroporto Faro - Bilbao (Espanha)', economico: 780, conforto: 840, suv: 900, mpv: 960, minivan: 1020, minibus: 1140, luxo: 1560 },
    { route: 'Aeroporto Faro - Gibraltar', economico: 320, conforto: 350, suv: 380, mpv: 410, minivan: 440, minibus: 500, luxo: 640 },
    { route: 'Aeroporto Faro - Girona (Espanha)', economico: 1020, conforto: 1080, suv: 1140, mpv: 1200, minivan: 1260, minibus: 1380, luxo: 2040 },
    { route: 'Aeroporto Faro - Granada (Espanha)', economico: 380, conforto: 420, suv: 460, mpv: 500, minivan: 540, minibus: 620, luxo: 760 },
    { route: 'Aeroporto Faro - Jerez (Espanha)', economico: 260, conforto: 290, suv: 320, mpv: 350, minivan: 380, minibus: 440, luxo: 520 },
    { route: 'Aeroporto Faro - La Linea (Espanha)', economico: 310, conforto: 340, suv: 370, mpv: 400, minivan: 430, minibus: 490, luxo: 620 },
    { route: 'Aeroporto Faro - Madrid (Espanha)', economico: 620, conforto: 670, suv: 720, mpv: 770, minivan: 820, minibus: 920, luxo: 1240 },
    { route: 'Aeroporto Faro - Malaga (Espanha)', economico: 340, conforto: 380, suv: 420, mpv: 460, minivan: 500, minibus: 580, luxo: 680 },
    { route: 'Aeroporto Faro - Murcia (Espanha)', economico: 520, conforto: 570, suv: 620, mpv: 670, minivan: 720, minibus: 820, luxo: 1040 },
    { route: 'Aeroporto Faro - Reus (Espanha)', economico: 960, conforto: 1020, suv: 1080, mpv: 1140, minivan: 1200, minibus: 1320, luxo: 1920 },
    { route: 'Aeroporto Faro - San Sebastian (Espanha)', economico: 860, conforto: 920, suv: 980, mpv: 1040, minivan: 1100, minibus: 1220, luxo: 1720 },
    { route: 'Aeroporto Faro - Santander (Espanha)', economico: 820, conforto: 880, suv: 940, mpv: 1000, minivan: 1060, minibus: 1180, luxo: 1640 },
    { route: 'Aeroporto Faro - Valencia (Espanha)', economico: 720, conforto: 780, suv: 840, mpv: 900, minivan: 960, minibus: 1080, luxo: 1440 },
  ];

  // Mapeamento de termos de pesquisa em múltiplos idiomas e variações
  const locationAliases: { [key: string]: string[] } = {
    'Aeroporto Faro': ['aeroporto', 'airport', 'faro airport', 'aeropuerto', 'flughafen', 'aéroport', 'fao', 'aeroport', 'aeroporto faro', 'faro'],
    'Albufeira': ['albufeira', 'albufiera', 'albufera', 'albuferia', 'albufira'],
    'Vilamoura': ['vilamoura', 'vila moura', 'vilamora', 'vila mora'],
    'Quarteira': ['quarteira', 'quartera', 'quarteira'],
    'Lagos': ['lagos', 'lago'],
    'Portimão': ['portimao', 'portimão', 'portimao', 'portimao', 'portimao'],
    'Carvoeiro': ['carvoeiro', 'carvoero', 'carveiro'],
    'Tavira': ['tavira', 'tavera'],
    'Sagres': ['sagres', 'sagre'],
    'Alvor': ['alvor', 'alvore'],
    'Armação de Pêra': ['armacao', 'armação', 'armacao de pera', 'armação de pêra', 'pera', 'armacao pera', 'armação pêra'],
    'Almancil': ['almancil', 'almansil', 'almancil'],
    'Quinta do Lago': ['quinta', 'quinta do lago', 'quinta lago', 'quinta lago', 'quintadolago'],
    'Vale do Lobo': ['vale', 'vale do lobo', 'vale lobo', 'valedolobo'],
    'Olhão': ['olhao', 'olhão', 'olhao', 'olhao'],
    'Monte Gordo': ['monte gordo', 'monte', 'montegordo'],
    'Vila Real de Santo António': ['vila real', 'vrsa', 'santo antonio', 'santo antónio', 'vila real santo antonio', 'vilareal'],
    'Ayamonte': ['ayamonte', 'espanha', 'spain', 'españa', 'ayamonte', 'aiamonte'],
    'Huelva': ['huelva', 'espanha', 'spain', 'españa', 'uelva'],
    'Sevilha': ['sevilha', 'sevilla', 'seville', 'espanha', 'spain', 'españa', 'sevilha'],
    'Lisboa': ['lisboa', 'lisbon', 'lisbonne', 'lisbon', 'lisbona'],
    'Praia da Rocha': ['praia da rocha', 'rocha', 'praiadarocha', 'praia rocha'],
    'Burgau': ['burgau', 'burgao'],
    'Salema': ['salema', 'salema'],
    'Praia da Luz': ['praia da luz', 'luz', 'praiadluz', 'praia luz'],
    'Montechoro': ['montechoro', 'monte choro', 'montechoro'],
    'Galé': ['gale', 'galé', 'gale'],
    'Olhos de Água': ['olhos', 'olhos de agua', 'olhos de água', 'agua', 'olhos agua', 'olhosdeagua'],
    'Ferragudo': ['ferragudo', 'ferragudo'],
    'Porches': ['porches', 'porche'],
    'Silves': ['silves', 'silve']
  };

  // Função de normalização melhorada
  const normalizeText = (text: string) => {
    return text
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove acentos
      .replace(/[^a-z0-9\s]/g, '') // Remove caracteres especiais
      .replace(/\s+/g, ' '); // Remove espaços extras
  };

  // Função de similaridade de Levenshtein (para detectar erros de digitação)
  const levenshteinDistance = (str1: string, str2: string): number => {
    const matrix: number[][] = [];

    for (let i = 0; i <= str2.length; i++) {
      matrix[i] = [i];
    }

    for (let j = 0; j <= str1.length; j++) {
      matrix[0][j] = j;
    }

    for (let i = 1; i <= str2.length; i++) {
      for (let j = 1; j <= str1.length; j++) {
        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }

    return matrix[str2.length][str1.length];
  };

  // Função de busca inteligente melhorada
  const smartSearch = (searchTerm: string): PricingRoute[] => {
    if (!searchTerm || searchTerm.length < 2) return routes;

    const normalizedSearch = normalizeText(searchTerm);
    const searchWords = normalizedSearch.split(' ').filter(word => word.length > 1);
    
    const scoredRoutes = routes.map(route => {
      let score = 0;
      const normalizedRoute = normalizeText(route.route);
      const routeParts = route.route.split(' - ');

      // 1. Correspondência exata (pontuação máxima)
      if (normalizedRoute.includes(normalizedSearch)) {
        score += 100;
      }

      // 2. Correspondência de palavras individuais
      searchWords.forEach(word => {
        if (normalizedRoute.includes(word)) {
          score += 50;
        }
      });

      // 3. Verificar aliases para cada parte da rota
      routeParts.forEach(part => {
        const partTrimmed = part.trim();
        const aliases = locationAliases[partTrimmed] || [];
        
        // Correspondência exata com alias
        aliases.forEach(alias => {
          const normalizedAlias = normalizeText(alias);
          if (normalizedAlias === normalizedSearch) {
            score += 90;
          } else if (normalizedAlias.includes(normalizedSearch) || normalizedSearch.includes(normalizedAlias)) {
            score += 70;
          }
          
          // Correspondência de palavras com alias
          searchWords.forEach(word => {
            if (normalizedAlias.includes(word)) {
              score += 40;
            }
          });
        });

        // 4. Similaridade de Levenshtein (para erros de digitação)
        const normalizedPart = normalizeText(partTrimmed);
        const distance = levenshteinDistance(normalizedSearch, normalizedPart);
        const maxLength = Math.max(normalizedSearch.length, normalizedPart.length);
        const similarity = 1 - (distance / maxLength);
        
        if (similarity > 0.7) { // 70% de similaridade
          score += Math.floor(similarity * 60);
        }

        // Verificar similaridade com aliases
        aliases.forEach(alias => {
          const normalizedAlias = normalizeText(alias);
          const aliasDistance = levenshteinDistance(normalizedSearch, normalizedAlias);
          const aliasMaxLength = Math.max(normalizedSearch.length, normalizedAlias.length);
          const aliasSimilarity = 1 - (aliasDistance / aliasMaxLength);
          
          if (aliasSimilarity > 0.7) {
            score += Math.floor(aliasSimilarity * 50);
          }
        });
      });

      // 5. Correspondência parcial no início (importante para autocompletar)
      routeParts.forEach(part => {
        const normalizedPart = normalizeText(part);
        if (normalizedPart.startsWith(normalizedSearch)) {
          score += 80;
        }
        
        const aliases = locationAliases[part.trim()] || [];
        aliases.forEach(alias => {
          const normalizedAlias = normalizeText(alias);
          if (normalizedAlias.startsWith(normalizedSearch)) {
            score += 75;
          }
        });
      });

      return { route, score };
    });

    // Filtrar rotas com pontuação > 0 e ordenar por pontuação
    return scoredRoutes
      .filter(item => item.score > 0)
      .sort((a, b) => b.score - a.score)
      .map(item => item.route);
  };

  const filteredRoutes = smartSearch(searchTerm);

  const handleBookRoute = (route: PricingRoute) => {
    setSelectedRoute(route);
    const bookingSection = document.getElementById('reservas');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const winterSeason = isWinterSeason();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-orange-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              {t('pricingTitle')}
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-4">
              {t('pricingSubtitle')}
            </p>
            <p className="text-base text-gray-500 max-w-2xl mx-auto">
              {t('pricingDescription')}
            </p>
            {winterSeason && (
              <div className="mt-6 inline-block bg-blue-50 border-2 border-blue-200 rounded-xl px-6 py-4">
                <div className="flex items-center space-x-3">
                  <i className="ri-snowflake-line text-3xl text-blue-600"></i>
                  <div className="text-left">
                    <div className="text-lg font-bold text-blue-900">{t('winterDiscount')}</div>
                    <div className="text-sm text-blue-700">{t('winterDiscountDescription')}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-12 bg-white border-y border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex items-center justify-center space-x-3">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <i className="ri-checkbox-circle-line text-2xl text-green-600"></i>
              </div>
              <div>
                <div className="font-semibold text-gray-900">{t('pricesIncludeVAT')}</div>
                <div className="text-sm text-gray-500">IVA incluído</div>
              </div>
            </div>
            <div className="flex items-center justify-center space-x-3">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <div className="font-semibold text-gray-900">{t('noHiddenFees')}</div>
                <div className="text-sm text-gray-500">Transparência total</div>
              </div>
            </div>
            <div className="flex items-center justify-center space-x-3">
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                <i className="ri-price-tag-3-line text-2xl text-orange-600"></i>
              </div>
              <div>
                <div className="font-semibold text-gray-900">{t('fixedPrices')}</div>
                <div className="text-sm text-gray-500">Sem surpresas</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Search Section */}
      <section className="py-8 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto">
            <div className="relative">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={t('searchRoute')}
                className="w-full px-6 py-4 pl-14 pr-4 text-base border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all"
              />
              <i className="ri-search-line absolute left-5 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl"></i>
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm('')}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className="ri-close-circle-line text-xl"></i>
                </button>
              )}
            </div>
            {searchTerm && (
              <div className="mt-3 text-sm text-gray-600 text-center">
                {filteredRoutes.length === 0 ? (
                  <span className="text-red-600">
                    <i className="ri-information-line"></i> {t('noRoutesFound')}
                  </span>
                ) : (
                  <span className="text-green-600">
                    <i className="ri-checkbox-circle-line"></i> {filteredRoutes.length} {filteredRoutes.length === 1 ? t('routeFound') : t('routesFound')}
                  </span>
                )}
              </div>
            )}
            <div className="mt-3 text-xs text-gray-500 text-center">
              <i className="ri-lightbulb-line"></i> Dica: Pode pesquisar em português, inglês ou espanhol. Exemplos: "airport", "aeroporto", "albufeira", "lagos"
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Table */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Desktop Table */}
          <div className="hidden lg:block bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold whitespace-nowrap sticky left-0 bg-gray-800 z-10">
                      {t('route')}
                    </th>
                    <th className="px-4 py-4 text-center text-sm font-semibold whitespace-nowrap">
                      {t('economico')}
                      <div className="text-xs font-normal text-gray-300">1-3 pax</div>
                    </th>
                    <th className="px-4 py-4 text-center text-sm font-semibold whitespace-nowrap">
                      {t('conforto')}
                      <div className="text-xs font-normal text-gray-300">1-3 pax</div>
                    </th>
                    <th className="px-4 py-4 text-center text-sm font-semibold whitespace-nowrap">
                      {t('suv')}
                      <div className="text-xs font-normal text-gray-300">1-4 pax</div>
                    </th>
                    <th className="px-4 py-4 text-center text-sm font-semibold whitespace-nowrap">
                      {t('mpv')}
                      <div className="text-xs font-normal text-gray-300">1-5 pax</div>
                    </th>
                    <th className="px-4 py-4 text-center text-sm font-semibold whitespace-nowrap">
                      {t('minivan')}
                      <div className="text-xs font-normal text-gray-300">1-6 pax</div>
                    </th>
                    <th className="px-4 py-4 text-center text-sm font-semibold whitespace-nowrap">
                      {t('minibus')}
                      <div className="text-xs font-normal text-gray-300">1-8 pax</div>
                    </th>
                    <th className="px-4 py-4 text-center text-sm font-semibold whitespace-nowrap">
                      {t('luxo')}
                      <div className="text-xs font-normal text-gray-300">1-3 pax</div>
                    </th>
                    <th className="px-6 py-4 text-center text-sm font-semibold whitespace-nowrap">
                      {t('action')}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filteredRoutes.map((route, index) => (
                    <tr key={index} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 text-sm font-medium text-gray-900 whitespace-nowrap sticky left-0 bg-white">
                        {route.route}
                      </td>
                      <td className="px-4 py-4 text-center text-sm text-gray-700 whitespace-nowrap">
                        {winterSeason && (
                          <div className="text-xs text-gray-400 line-through">€{route.economico}</div>
                        )}
                        <div className={winterSeason ? 'font-bold text-blue-600' : ''}>
                          €{applyWinterDiscount(route.economico, route.route).toFixed(0)}
                        </div>
                      </td>
                      <td className="px-4 py-4 text-center text-sm text-gray-700 whitespace-nowrap">
                        {winterSeason && (
                          <div className="text-xs text-gray-400 line-through">€{route.conforto}</div>
                        )}
                        <div className={winterSeason ? 'font-bold text-blue-600' : ''}>
                          €{applyWinterDiscount(route.conforto, route.route).toFixed(0)}
                        </div>
                      </td>
                      <td className="px-4 py-4 text-center text-sm text-gray-700 whitespace-nowrap">
                        {winterSeason && (
                          <div className="text-xs text-gray-400 line-through">€{route.suv}</div>
                        )}
                        <div className={winterSeason ? 'font-bold text-blue-600' : ''}>
                          €{applyWinterDiscount(route.suv, route.route).toFixed(0)}
                        </div>
                      </td>
                      <td className="px-4 py-4 text-center text-sm text-gray-700 whitespace-nowrap">
                        {winterSeason && (
                          <div className="text-xs text-gray-400 line-through">€{route.mpv}</div>
                        )}
                        <div className={winterSeason ? 'font-bold text-blue-600' : ''}>
                          €{applyWinterDiscount(route.mpv, route.route).toFixed(0)}
                        </div>
                      </td>
                      <td className="px-4 py-4 text-center text-sm text-gray-700 whitespace-nowrap">
                        {winterSeason && (
                          <div className="text-xs text-gray-400 line-through">€{route.minivan}</div>
                        )}
                        <div className={winterSeason ? 'font-bold text-blue-600' : ''}>
                          €{applyWinterDiscount(route.minivan, route.route).toFixed(0)}
                        </div>
                      </td>
                      <td className="px-4 py-4 text-center text-sm text-gray-700 whitespace-nowrap">
                        {winterSeason && (
                          <div className="text-xs text-gray-400 line-through">€{route.minibus}</div>
                        )}
                        <div className={winterSeason ? 'font-bold text-blue-600' : ''}>
                          €{applyWinterDiscount(route.minibus, route.route).toFixed(0)}
                        </div>
                      </td>
                      <td className="px-4 py-4 text-center text-sm text-gray-700 whitespace-nowrap">
                        {winterSeason && (
                          <div className="text-xs text-gray-400 line-through">€{route.luxo}</div>
                        )}
                        <div className={winterSeason ? 'font-bold text-blue-600' : ''}>
                          €{applyWinterDiscount(route.luxo, route.route).toFixed(0)}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-center whitespace-nowrap">
                        <button
                          onClick={() => handleBookRoute(route)}
                          className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                        >
                          {t('bookThisRoute')}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile Cards */}
          <div className="lg:hidden space-y-4">
            {filteredRoutes.map((route, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden">
                <div className="bg-gray-800 text-white px-4 py-3">
                  <h3 className="font-semibold text-sm">{route.route}</h3>
                </div>
                <div className="p-4">
                  <div className="grid grid-cols-2 gap-3 mb-4">
                    <div className="bg-gray-50 rounded-lg p-3">
                      <div className="text-xs text-gray-500 mb-1">{t('economico')}</div>
                      {winterSeason && (
                        <div className="text-xs text-gray-400 line-through">€{route.economico}</div>
                      )}
                      <div className={`text-lg font-bold ${winterSeason ? 'text-blue-600' : 'text-gray-900'}`}>
                        €{applyWinterDiscount(route.economico, route.route).toFixed(0)}
                      </div>
                      <div className="text-xs text-gray-400">1-3 pax</div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-3">
                      <div className="text-xs text-gray-500 mb-1">{t('conforto')}</div>
                      {winterSeason && (
                        <div className="text-xs text-gray-400 line-through">€{route.conforto}</div>
                      )}
                      <div className={`text-lg font-bold ${winterSeason ? 'text-blue-600' : 'text-gray-900'}`}>
                        €{applyWinterDiscount(route.conforto, route.route).toFixed(0)}
                      </div>
                      <div className="text-xs text-gray-400">1-3 pax</div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-3">
                      <div className="text-xs text-gray-500 mb-1">{t('suv')}</div>
                      {winterSeason && (
                        <div className="text-xs text-gray-400 line-through">€{route.suv}</div>
                      )}
                      <div className={`text-lg font-bold ${winterSeason ? 'text-blue-600' : 'text-gray-900'}`}>
                        €{applyWinterDiscount(route.suv, route.route).toFixed(0)}
                      </div>
                      <div className="text-xs text-gray-400">1-4 pax</div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-3">
                      <div className="text-xs text-gray-500 mb-1">{t('mpv')}</div>
                      {winterSeason && (
                        <div className="text-xs text-gray-400 line-through">€{route.mpv}</div>
                      )}
                      <div className={`text-lg font-bold ${winterSeason ? 'text-blue-600' : 'text-gray-900'}`}>
                        €{applyWinterDiscount(route.mpv, route.route).toFixed(0)}
                      </div>
                      <div className="text-xs text-gray-400">1-5 pax</div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-3">
                      <div className="text-xs text-gray-500 mb-1">{t('minivan')}</div>
                      {winterSeason && (
                        <div className="text-xs text-gray-400 line-through">€{route.minivan}</div>
                      )}
                      <div className={`text-lg font-bold ${winterSeason ? 'text-blue-600' : 'text-gray-900'}`}>
                        €{applyWinterDiscount(route.minivan, route.route).toFixed(0)}
                      </div>
                      <div className="text-xs text-gray-400">1-6 pax</div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-3">
                      <div className="text-xs text-gray-500 mb-1">{t('minibus')}</div>
                      {winterSeason && (
                        <div className="text-xs text-gray-400 line-through">€{route.minibus}</div>
                      )}
                      <div className={`text-lg font-bold ${winterSeason ? 'text-blue-600' : 'text-gray-900'}`}>
                        €{applyWinterDiscount(route.minibus, route.route).toFixed(0)}
                      </div>
                      <div className="text-xs text-gray-400">1-8 pax</div>
                    </div>
                    <div className="bg-orange-50 rounded-lg p-3 col-span-2">
                      <div className="text-xs text-orange-600 mb-1">{t('luxo')}</div>
                      {winterSeason && (
                        <div className="text-xs text-orange-400 line-through">€{route.luxo}</div>
                      )}
                      <div className={`text-xl font-bold ${winterSeason ? 'text-blue-600' : 'text-orange-600'}`}>
                        €{applyWinterDiscount(route.luxo, route.route).toFixed(0)}
                      </div>
                      <div className="text-xs text-orange-400">1-3 pax</div>
                    </div>
                  </div>
                  <button
                    onClick={() => handleBookRoute(route)}
                    className="w-full bg-orange-500 hover:bg-orange-600 text-white px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {t('bookThisRoute')}
                  </button>
                </div>
              </div>
            ))}
          </div>

          {filteredRoutes.length === 0 && (
            <div className="text-center py-12">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-search-line text-4xl text-gray-400"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {t('noRoutesFound')}
              </h3>
              <p className="text-gray-600 mb-6">
                {t('tryDifferentSearch')}
              </p>
              <button
                onClick={() => setSearchTerm('')}
                className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('clearSearch')}
              </button>
            </div>
          )}

          {/* Info Cards */}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">
                    {t('importantInfo')}
                  </h3>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-500 mt-0.5 flex-shrink-0"></i>
                      <span>{t('oneWayPrices')}</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-500 mt-0.5 flex-shrink-0"></i>
                      <span>{t('roundTripDiscount')}</span>
                    </li>
                    {winterSeason && (
                      <li className="flex items-start">
                        <i className="ri-arrow-right-s-line text-blue-500 mt-0.5 flex-shrink-0"></i>
                        <span className="font-semibold text-blue-600">{t('winterDiscountActive')}</span>
                      </li>
                    )}
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-500 mt-0.5 flex-shrink-0"></i>
                      <span>{t('pricesIncludeTax')}</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-500 mt-0.5 flex-shrink-0"></i>
                      <span>{t('noWaitingCosts')}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-double-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">
                    {t('allVehiclesInclude')}
                  </h3>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0"></i>
                      <span>{t('professionalDriver')}</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0"></i>
                      <span>{t('freeWifi')}</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0"></i>
                      <span>{t('airConditioning')}</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0"></i>
                      <span>{t('freeWater')}</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0"></i>
                      <span>{t('flightMonitoring')}</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0"></i>
                      <span>{t('meetAndGreet')}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Section */}
      <section id="reservas" className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              {t('bookingTitle')}
            </h2>
            {selectedRoute && (
              <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 inline-block">
                <div className="text-sm text-orange-800">
                  <i className="ri-map-pin-line"></i> Rota selecionada:
                </div>
                <div className="font-semibold text-orange-900 text-lg">
                  {selectedRoute.route}
                </div>
              </div>
            )}
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 shadow-lg">
            <BookingForm selectedRoute={selectedRoute} winterSeason={winterSeason} />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

function BookingForm({ selectedRoute, winterSeason }: { selectedRoute: PricingRoute | null; winterSeason: boolean }) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    from: selectedRoute ? selectedRoute.route.split(' - ')[0] : '',
    to: selectedRoute ? selectedRoute.route.split(' - ')[1] : '',
    date: '',
    time: '',
    passengers: '1',
    vehicleType: 'economico',
    returnTrip: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'success' | 'error' | null>(null);
  const [reservationNumber, setReservationNumber] = useState<number | null>(null);

  // Definir capacidade de passageiros por tipo de veículo
  const vehicleCapacity: { [key: string]: number } = {
    economico: 3,
    conforto: 3,
    suv: 4,
    mpv: 5,
    minivan: 6,
    minibus: 8,
    luxo: 3
  };

  // Função para obter o tipo de veículo mínimo necessário baseado no número de passageiros
  const getMinimumVehicleType = (passengers: number): string => {
    if (passengers <= 3) return 'economico';
    if (passengers === 4) return 'suv';
    if (passengers === 5) return 'mpv';
    if (passengers === 6) return 'minivan';
    if (passengers <= 8) return 'minibus';
    return 'minibus';
  };

  // Atualizar tipo de veículo quando o número de passageiros mudar
  useEffect(() => {
    const numPassengers = parseInt(formData.passengers);
    const currentCapacity = vehicleCapacity[formData.vehicleType];
    
    if (numPassengers > currentCapacity) {
      const newVehicleType = getMinimumVehicleType(numPassengers);
      setFormData(prev => ({ ...prev, vehicleType: newVehicleType }));
    }
  }, [formData.passengers]);

  const calculatePrice = () => {
    if (!selectedRoute) return 0;
    const vehicleType = formData.vehicleType as keyof PricingRoute;
    let basePrice = selectedRoute[vehicleType] as number;
    
    // Aplicar desconto de inverno (10% para Espanha, 30% para Portugal)
    if (winterSeason) {
      basePrice = isSpainRoute(selectedRoute.route) ? basePrice * 0.9 : basePrice * 0.7;
    }
    
    // Aplicar desconto de ida e volta (10% adicional)
    if (formData.returnTrip) {
      return basePrice * 2 * 0.9;
    }
    
    return basePrice;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
      const price = calculatePrice();
      
      const response = await fetch(`${supabaseUrl}/functions/v1/create-reservation-pdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customerName: formData.name,
          customerEmail: formData.email,
          customerPhone: formData.phone,
          fromLocation: formData.from,
          toLocation: formData.to,
          travelDate: formData.date,
          travelTime: formData.time,
          passengers: formData.passengers,
          vehicleType: formData.vehicleType,
          price: price,
          returnTrip: formData.returnTrip
        })
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setSubmitStatus('success');
        setReservationNumber(result.reservationNumber);
        
        setFormData({
          name: '',
          email: '',
          phone: '',
          from: '',
          to: '',
          date: '',
          time: '',
          passengers: '1',
          vehicleType: 'economico',
          returnTrip: false
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Erro ao criar reserva:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('name')}
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({...formData, name: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('email')}
          </label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('phone')}
          </label>
          <input
            type="tel"
            value={formData.phone}
            onChange={(e) => setFormData({...formData, phone: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('from')}
          </label>
          <input
            type="text"
            value={formData.from}
            onChange={(e) => setFormData({...formData, from: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('to')}
          </label>
          <input
            type="text"
            value={formData.to}
            onChange={(e) => setFormData({...formData, to: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('date')}
          </label>
          <input
            type="date"
            value={formData.date}
            onChange={(e) => setFormData({...formData, date: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('time')}
          </label>
          <input
            type="time"
            value={formData.time}
            onChange={(e) => setFormData({...formData, time: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('passengers')}
          </label>
          <select
            value={formData.passengers}
            onChange={(e) => setFormData({...formData, passengers: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
          >
            {[1,2,3,4,5,6,7,8].map(num => (
              <option key={num} value={num}>
                {num} {num === 1 ? t('passengerSingular') : t('passengerPlural')}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('vehicleType')}
          </label>
          <select
            value={formData.vehicleType}
            onChange={(e) => setFormData({...formData, vehicleType: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
          >
            <option value="economico" disabled={parseInt(formData.passengers) > 3}>
              {t('economico')} (1-3 pax)
            </option>
            <option value="conforto" disabled={parseInt(formData.passengers) > 3}>
              {t('conforto')} (1-3 pax)
            </option>
            <option value="suv" disabled={parseInt(formData.passengers) > 4}>
              {t('suv')} (1-4 pax)
            </option>
            <option value="mpv" disabled={parseInt(formData.passengers) > 5}>
              {t('mpv')} (1-5 pax)
            </option>
            <option value="minivan" disabled={parseInt(formData.passengers) > 6}>
              {t('minivan')} (1-6 pax)
            </option>
            <option value="minibus">
              {t('minibus')} (1-8 pax)
            </option>
            <option value="luxo" disabled={parseInt(formData.passengers) > 3}>
              {t('luxo')} (1-3 pax)
            </option>
          </select>
          {parseInt(formData.passengers) > vehicleCapacity[formData.vehicleType] && (
            <div className="mt-2 text-xs text-orange-600 flex items-start">
              <i className="ri-information-line mr-1 mt-0.5"></i>
              <span>Veículo ajustado automaticamente para {formData.passengers} passageiros</span>
            </div>
          )}
        </div>

        <div className="flex items-center">
          <label className="flex items-center space-x-3 cursor-pointer">
            <input
              type="checkbox"
              checked={formData.returnTrip}
              onChange={(e) => setFormData({...formData, returnTrip: e.target.checked})}
              className="w-5 h-5 text-orange-500 border-gray-300 rounded focus:ring-orange-500"
            />
            <span className="text-sm font-medium text-gray-700">
              {t('returnTrip')} (-10%)
            </span>
          </label>
        </div>
      </div>

      {selectedRoute && (
        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="text-sm text-green-800">{t('totalValue')}:</div>
            <div className="text-3xl font-bold text-green-600">
              €{calculatePrice().toFixed(2)}
            </div>
          </div>
          {winterSeason && (
            <div className="text-xs text-blue-700 mt-1 text-right">
              <i className="ri-snowflake-line"></i> {t('winterDiscountApplied')}
            </div>
          )}
          {formData.returnTrip && (
            <div className="text-xs text-green-700 mt-1 text-right">
              {t('discountApplied')}
            </div>
          )}
        </div>
      )}

      {submitStatus === 'success' && (
        <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-center">
          <strong>{t('bookingConfirmed')}</strong>
          {reservationNumber && (
            <div className="mt-1">{t('reservationNumber')}: <strong>#{reservationNumber}</strong></div>
          )}
          <div className="text-sm mt-1">{t('pdfSentTo')}</div>
        </div>
      )}

      {submitStatus === 'error' && (
        <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-center">
          {t('bookingError')}
        </div>
      )}

      <div className="text-center pt-6">
        <button
          type="submit"
          disabled={isSubmitting}
          className="bg-orange-500 hover:bg-orange-600 text-white px-12 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
        >
          {isSubmitting ? t('processing') : t('bookNow')}
        </button>
      </div>
    </form>
  );
}
